import { faCircleCheck, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate } from 'react-router-dom';
import type { ToastOptions } from 'react-toastify';
import styled from 'styled-components';
import { WxLabel, WxText } from '../..';
import { __ } from '../../../i18n/l10n';
import { appendCommitHash } from '../../../utils/appendHash';

interface Props {
  label: string;
  link: string;
  closeToast?: () => void;
  toastProps: ToastOptions;
}

export const Toast = ({ label, link, closeToast, toastProps }: Props) => {
  const navigate = useNavigate();

  return (
    <Wrapper onClick={() => navigate(appendCommitHash(link))}>
      <div>
        <Icon icon={faCircleCheck} />
        <WxText size="small" text={label} uppercase darkMode bold />
      </div>
      <Row>
        <Link to={appendCommitHash(link)}>
          <WxLabel label={__('View')} />
        </Link>
        <Icon
          icon={faTimes}
          onClick={(e) => {
            e.stopPropagation();
            closeToast && closeToast();
          }}
          $pointer
        />
      </Row>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.green};
  padding: 1.125rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 280px;

  > div {
    display: flex;
    gap: 0.625rem;
    align-items: center;
  }
`;
const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 20px;
`;

const Icon = styled(FontAwesomeIcon)<{ $pointer?: boolean }>`
  color: ${({ theme }) => theme.colors.white};
  font-size: 1.25rem;
  cursor: ${({ $pointer }) => ($pointer ? 'pointer' : 'default')};
`;
